import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IWorkspaceTrustEnablementService, IWorkspaceTrustManagementService, IWorkspaceTrustRequestService } from 'vscode/vscode/vs/platform/workspace/common/workspaceTrust.service';
import { WorkspaceTrustEnablementService, WorkspaceTrustManagementService, WorkspaceTrustRequestService } from 'vscode/vscode/vs/workbench/services/workspaces/common/workspaceTrust';
import './vscode/src/vs/workbench/contrib/workspace/browser/workspace.contribution.js';

function getServiceOverride() {
    return {
        [( IWorkspaceTrustEnablementService.toString())]: new SyncDescriptor(WorkspaceTrustEnablementService),
        [( IWorkspaceTrustManagementService.toString())]: new SyncDescriptor(WorkspaceTrustManagementService),
        [( IWorkspaceTrustRequestService.toString())]: new SyncDescriptor(WorkspaceTrustRequestService)
    };
}

export { getServiceOverride as default };
